import React from "react";
import { v4 as uuidv4 } from "uuid";
import Pill from "../../../../components/atoms/Pill";
import { tierColors, tableHeaders, hallmarkTableHeaders } from "./constants";
import Expander from "../../../../components/Expander";
import helpers from "../../../../common/utils/utils";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";

const getArrayValues = (values) => {
  return values && values.length > 0
    ? values.map((value) => {
        const key = uuidv4();
        return (
          <span className="tw-block" key={key}>
            {value}
          </span>
        );
      })
    : "-";
};

const getBooleanValue = (keyValue) => {
  if (keyValue) {
    return "True";
  }
  return "False";
};

const getTier = (tier) => {
  return (
    <Pill
      style={{ padding: "0.5rem", fontSize: "1rem" }}
      color={tierColors[tier]}
    >
      {tier}
    </Pill>
  );
};

const getCellData = (row, key) => {
  switch (key) {
    case "tier":
      return getTier(row[key]);
    case "cancer_syndrome":
    case "germline_tumours":
    case "somatic_tumours":
    case "mutation_types":
    case "role_in_cancer":
    case "tissue_type":
    case "translocation_partner":
      return getArrayValues(row[key]);
    case "germline":
    case "somatic":
      return getBooleanValue(row[key]);
    default:
      return row[key] || "-";
  }
};

const getRowData = (rowData) => {
  const tableKeys = tableHeaders.map((r) => r.id);
  return tableKeys.map((key) => ({
    id: uuidv4(),
    content: getCellData(rowData, key),
  }));
};

export const getTableRowsToRender = (data) => {
  const rowData = getRowData(data);
  return [
    {
      id: uuidv4(),
      columns: rowData,
    },
  ];
};

const getHallmarkRow = (item) => {
  let rows = [];
  if (item?.details && item?.details?.length > 0) {
    const title = helpers.capitalizeFirstLetter(
      item.title.replaceAll("_", " ")
    );
    rows = item.details.map((i, j) => {
      if (j === 0) {
        return (
          <tr key={uuidv4()}>
            <td rowSpan={item.details.length}>{title}</td>
            <td>
              {i.cell_type ? helpers.capitalizeFirstLetter(i.cell_type) : "-"}
            </td>
            <td>
              {i.description
                ? helpers.capitalizeFirstLetter(i.description)
                : "-"}
            </td>
            <td>{i.impact ? helpers.capitalizeFirstLetter(i.impact) : "-"}</td>
            <td>
              {i.pub_med_references ? (
                <PublicationLinks ids={i.pub_med_references} />
              ) : (
                "-"
              )}
            </td>
          </tr>
        );
      }
      return (
        <tr key={uuidv4()}>
          <td>
            {i.cell_type ? helpers.capitalizeFirstLetter(i.cell_type) : "-"}
          </td>
          <td>
            {i.description ? helpers.capitalizeFirstLetter(i.description) : "-"}
          </td>
          <td>{i.impact ? helpers.capitalizeFirstLetter(i.impact) : "-"}</td>
          <td>
            {i.pub_med_references ? (
              <PublicationLinks ids={i.pub_med_references} />
            ) : (
              "-"
            )}
          </td>
        </tr>
      );
    });
  }
  return rows;
};

export const getHallmarkTable = (items) => {
  const tableHeader = hallmarkTableHeaders.map((header) => {
    return (
      <th key={header.title} style={header.style}>
        {header.title}
      </th>
    );
  });

  const rows = items.map((item) => {
    return getHallmarkRow(item);
  });

  const data = (
    <table className="varsome-table tw-break">
      <thead>
        <tr>{tableHeader}</tr>
      </thead>
      <Expander showMore="5" columns="4" component="tbody">
        {rows}
      </Expander>
    </table>
  );
  return data;
};

export const hallmarkDataPreparation = (hallmarkData) => {
  const b = [];
  Object.keys(hallmarkData).forEach((key) => {
    if (hallmarkData[key]) {
      const c = { title: key, details: hallmarkData[key] };
      b.push(c);
    }
  });
  return b;
};
